/**
 * Fork startup hook (web) — the ONE place a downstream fork wires the runtime
 * web `register*()` seams that must run before render (as opposed to the
 * `*.extensions.*` arrays auto-imported by the app shell).
 *
 * Upstream is a no-op side-effect module. `app.tsx` imports it at the top so a
 * fork registers its Global-Agent URL context resolvers and locale messages here
 * WITHOUT editing app.tsx.
 *
 * Fork example (in the fork's copy of this file):
 *   import { registerUrlContextResolver } from './lib/context-resolvers';
 *   import { registerLocaleMessages } from './lib/i18n';
 *   registerUrlContextResolver('crm', (subPath) => ({ type: 'crm', module: subPath || undefined }));
 *   registerLocaleMessages('zh', { crm: { title: 'CRM' } });
 */

import { registerUrlContextResolver } from './lib/context-resolvers';
import { registerLocaleMessages } from './lib/i18n';
import { crmEn, crmZh } from './lib/i18n/crm-messages';
import { feishuEn, feishuZh } from './lib/i18n/feishu-messages';

// CRM + Feishu (S5-i18n): make t('crm.*') / t('feishu.*') resolve without
// editing the upstream en/zh bundles.
registerLocaleMessages('en', { crm: crmEn, feishu: feishuEn });
registerLocaleMessages('zh', { crm: crmZh, feishu: feishuZh });

// CRM (S10): map '#/crm/<module>[/<id>]' to a Global-Agent page context so the
// agent panel knows which CRM screen the user is on.
registerUrlContextResolver('crm', (subPath) => {
  const segs = subPath.split('/').filter(Boolean);
  const module = segs[0] || 'home';
  const itemId = segs[1] || undefined;
  return { type: 'crm', module, title: itemId ? `${module} #${itemId}` : undefined };
});
